<div class="grid">
  <div class="col-6">
    <p-dropdown [options]="monthSelectionOptions"
                [(ngModel)]="selectedOption"
                optionLabel="name"
                variant="filled"
                placeholder="Выбрать диапазон"
                (onChange)="onMonthOptionsClick($event)" />
  </div>
  <div class="col-6 text-right">
    <button pButton type="button" label="Обновить" icon="pi pi-refresh" (click)="updateData()"></button>
  </div>

  <div class="col-12 text-center">
    <p-progressSpinner *ngIf="loading" ariaLabel="loading" [style]="{width: '100%', height: '25rem'}" />
    <p-chart *ngIf="!loading" type="bar" [data]="dataMonthlyPayments" [options]="monthlyGraphOptions" (onDataSelect)="selectData($event)" width="100%" height="25rem"></p-chart>
  </div>
</div>
